import { FC, useEffect, useState } from 'react'
import _Select, { components, Props } from 'react-select'
import classNames from 'classnames'

const SelectIcon = ({ className, ...rest }: any) => {
  return (
    <svg
      className={classNames('input-icon', className)}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 15.5C11.744 15.5 11.488 15.402 11.293 15.207L7.29301 11.207C6.90201 10.816 6.90201 10.184 7.29301 9.79301C7.68401 9.40201 8.31601 9.40201 8.70701 9.79301L12.012 13.098L15.305 9.91801C15.704 9.53501 16.335 9.54601 16.719 9.94301C17.103 10.34 17.092 10.974 16.695 11.357L12.695 15.219C12.5 15.407 12.25 15.5 12 15.5Z'
      />
    </svg>
  )
}

export type SelectType = Props & {
  isValid?: boolean
  shouldValidate?: boolean
}

const Control = ({ children, ...props }: any) => (
  <components.Control className='select-form-control' {...props}>
    {children}
  </components.Control>
)
const Select: FC<SelectType> = ({
  isValid,
  shouldValidate: _shouldValidate,
  ...rest
}) => {
  const [shouldValidate, setShouldValidate] = useState(false)
  useEffect(() => {
    if (_shouldValidate) {
      setShouldValidate(true)
    }
  }, [_shouldValidate])
  return (
    <div
      className={classNames(
        'position-relative input-container',
        rest.className,
        {
          invalid: isValid === false && !!shouldValidate,
        },
      )}
    >
      <_Select
        onBlur={() => {
          setShouldValidate(true)
        }}
        {...rest}
        components={{
          Control,
          DropdownIndicator: SelectIcon,
          ...rest.components,
        }}
        classNamePrefix={'select'}
        className='select'
      />
    </div>
  )
}

export default Select
